var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#calculation_svg__clip0_61530_7419)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6h-3V3H6v3H3v1.5h3v3h1.5v-3h3V6zM10.5 14.25H3v1.5h7.5v-1.5zM10.5 18H3v1.5h7.5V18zM21 6h-7.5v1.5H21V6zM18.308 16.5L21 13.807l-1.058-1.057-2.692 2.693-2.693-2.693-1.057 1.057 2.692 2.693-2.692 2.692 1.057 1.058 2.693-2.692 2.692 2.692L21 19.192 18.308 16.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "calculation_svg__clip0_61530_7419"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgCalculation;